// extracted by mini-css-extract-plugin
module.exports = {"tick":"Tick--tick--d3WMr"};